import L from 'leaflet';

import ReactDOM from 'react-dom';
import { useState } from "react";

import Select from "react-select";

import {linkedtpArray, SetLastLinkedObj, GetLastLinkedObj, PushShowingLinkedObjects} from './PPManager';
import {PopupBehavior, map, GetLastInsertedId, SetLastInsertedId, SetLastOpenedPopup, MarkerClick, GetUserPermissions, GetUserName, isMobileVersion, loadedMarkers,
  DeleteObjectWithConfirm, StartCurveLine, OpenSideBar, SetCurrentBottomSheet, GetUserId, HighlightMarker, ClearMarkerHighlight } from './Main.js'
import {AddLine, updatePolylineByFromId, updatePolylineByToId } from './lines.js'
import {DrawPoleMarker, GetLastInsertedMarker, SetLastInsertedMarker} from './MarkerManager'
import { SearchComponent } from "../react-components/search/SearchComponent";

import { ObjectBottomSheet } from '../react-components/mobile/ObjectBottomSheet';
import { AddLineSheet } from '../react-components/mobile/AddLineSheet';
import { EditPoleSheet } from '../react-components/mobile/EditPoleSheet';

import imageSrcOctagon from '../images/octagon.png';
import imageSrcCircleSquare from '../images/circle_square.png';
import imageSrcTriangle from '../images/triangle.png';
import imageSrcWelded from '../images/welded.png';
import imageSrcNoType from '../images/notype2.png';


var poleType = 22;
//window.selectedPoleValue = 22;

var lastPoleType = null;
var lastPoleNumber = '1';
var lastTextPosition = '0';
var lastTypeLine = '8';

var lastLuminaireBrand = '1';
var lastCableBrand = '1';
var lastBracketBrand = '1';
var lastCableSection = '1';
var lastLengthBetweenPoles = '0';

var lastPlafondCount = '1';
var lastSocleCount = '1';
var lastBannerCount = '0';
var lastPodveskaCount = '0';
var lastLengthPodveska = '0';
var lastPoleState = '1';
var lastLuminaireState = '1';

var lastMyDiv = null;

const poleOptions = [
  { value: 22, label: "-" },
  { value: 2, label: "стальная граненная коническая СГКФ улица" },
  { value: 15, label: "стальная граненная коническая СГКФ двор" },
  { value: 16, label: "стальная граненная коническая СГКФ магистраль" },
  { value: 3, label: "стальная коническая СКФ улица" },
  { value: 17, label: "стальная коническая СКФ двор" },
  { value: 18, label: "стальная коническая СКФ магистраль" },
  { value: 19, label: "труба стальная сварная улица" },
  { value: 20, label: "труба стальная сварная двор" },
  { value: 21, label: "труба стальная сварная магистраль" },
  { value: 4, label: "ж/б" },
  { value: 5, label: "деревянная" },
  { value: 14, label: "торшерная" }
];

export function LoadAllPoles() {
    UnLoadAllPoles();
    //fetch(`${process.env.REACT_APP_BASE_URL}/load_all_poles`)
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_all_poles`)
    .then(response => response.json())
    .then(data => {
      // Добавление на карту объектов в зависимости от их типа
      data.forEach(object => {

        var foundObject = linkedtpArray.find(function(mainObject) {
          return mainObject.name === object.linkedtp;
        });
        if (foundObject == null) {
            var ppObject = {
              id: 0,
              name: object.linkedtp,
              children: [],
              lines: []
            };
          foundObject = ppObject;
          linkedtpArray.push(ppObject);
        }
        //if (foundObject != null && !hasChildWithId(foundObject, object.id)) {
            const latlng = L.latLng(object.lat, object.lng);
            const circle = DrawPoleMarker([object.lat, object.lng], object.typecode.toString(), /*object.countPlafond*/null, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
            

            var childObject1_1 = {
                id: object.id,
                name: object.name,
                circle: circle,
                typecode: object.typecode,
                latlng: latlng
              };

              // Используем метод find() для поиска объекта по имени
              
              
              if (foundObject) {
               
                foundObject.children.push(childObject1_1);
              } else {
              //  console.log('Объект с указанным именем не найден');
              }

            PolePopupSetup(circle, object.name, object.linkedtp, object.lat.toFixed(5), object.lng.toFixed(5), object.id);
            PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);
      //  }
      });
    })
    .catch(error => console.error(error));
}

/*function hasChildWithId(mainObject, childId) {
  return mainObject.children.some(function(child) {
    return child.id === childId;
  });
}*/

export function UnLoadAllPoles() {
    linkedtpArray.forEach(foundObject => { 
        foundObject.children.forEach(object => {   
            object.circle.remove();
        });
        foundObject.children = [];
    });      
}

const handlePoleChange = (option) => {
      poleType = option.value;
    };  

function PoleTypeSelect({ initialValue }) {
  
  const [poleTypeId, setPoleTypeId] = useState(initialValue);
  poleType = poleTypeId;
  
  return (
    <Select
      options={poleOptions}
      value={poleOptions.find(opt => opt.value === poleTypeId)}
      onChange={(option) => {setPoleTypeId(option.value); handlePoleChange(option);}}
      menuPlacement="auto"
      placeholder="Выберите тип опоры"
      menuPortalTarget={document.body} // 🔥 чтобы не вылазил из модалки
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
    />
  );
}

export function AddPoleSetup(latlng, currentTime) {
    //Метод добавления кругов на карту
    
    document.getElementById(`circle-btn${currentTime}`).addEventListener('click', function() {

      if (isMobileVersion) {
        const container = document.createElement('div');
        document.body.appendChild(container);
        SetCurrentBottomSheet(container);

        const handleClose = () => {
          ReactDOM.unmountComponentAtNode(container);
          container.remove();
        };

        // Питающим центром для опоры может быть только ПС (typecode = 13),
        // поэтому используем searchPP, а не общий searchPPandTP.
        const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;

        ReactDOM.render(
          <EditPoleSheet
            title="Добавить опору"
            initialNumber={String(lastPoleNumber)}
            initialLinkedtp={GetLastLinkedObj()}
            initialTextPosition={parseInt(lastTextPosition)}
            initialCableBrand={parseInt(lastCableBrand)}
            initialCableSection={parseInt(lastCableSection)}
            initialLengthBetweenPoles={parseInt(lastLengthBetweenPoles)}
            searchLink={searchLink}
            onClose={handleClose}
            onSave={(data) => {
              CheckLinkedtpIsPS(data.linkedtp).then(isValidPS => {
                if (!isValidPS) {
                  alert('Указанный питающий центр не найден среди ПС');
                  return;
                }
                CheckPoleDuplicate(data.linkedtp, data.number, null).then(isDuplicate => {
                  if (isDuplicate) {
                    alert('Опора с таким номером уже существует');
                    return;
                  }
                  AddPoleDirect(latlng, data);
                  handleClose();
                });
              });
            }}
          />,
          container
        );
        return;
      }

  //  window.selectedPoleValue = 22;

        var polePopupDiv = document.createElement('div');
		polePopupDiv.id = 'polePopup';
        
		document.body.appendChild(polePopupDiv);

		document.getElementById('polePopup').innerHTML = GetPoleHtmlContent(lastPoleNumber, GetLastLinkedObj(), false); //poleNumberContent + mainObjectNumberContent + popupContent + quantityPlafondContent + textPosition + submitContent;				


    

    var linkedtp = GetLastLinkedObj();
    const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPPandTP?name=`;
    function handeleClickFind(id, name, lat, lng) {
      
      linkedtp = name;
    }

    const container = document.getElementById('divMainObjectNumber');
    ReactDOM.render(<div className="div__flex" ><label for="mainObjectNumber">Питающий центр: </label><div id="mainObjectNumber" style={{zIndex: 5}}><SearchComponent
      handeleClickFind={handeleClickFind}
      link={searchLink}
      home={false}
      propsValue={linkedtp}
    ></SearchComponent></div></div>, container);

    const containerPoleType = document.getElementById('divPoleType');
    ReactDOM.render(<div  ><label for="divPoleType">Тип опоры:</label><div id="divPoleType"><PoleTypeSelect initialValue={poleType}
      /></div></div>, containerPoleType);

    var poleNumberText = document.getElementById('poleNumber');
    

    if (lastPoleType != null) {
      //document.getElementById("poleType" /*+ lastPoleType*/).value = lastPoleType;
     // window.selectedPoleValue = lastPoleType;
      poleType = lastPoleType;
    }
    document.getElementById("textPosition").value = lastTextPosition;
 //   document.getElementById("luminaireBrand").value = lastLuminaireBrand;
 //   document.getElementById("bracketBrand").value = lastBracketBrand;
    document.getElementById("cableBrand").value = lastCableBrand;
    document.getElementById("cableSection").value = lastCableSection;
    document.getElementById("lengthBetweenPoles").value = lastLengthBetweenPoles;
   // document.getElementById("quantityPlafond").value = lastPlafondCount;
  //  document.getElementById("socleCount").value = lastSocleCount;
  //  document.getElementById("bannerCount").value = lastBannerCount;
  //  document.getElementById("podveskaCount").value = lastPodveskaCount;
   // document.getElementById("lengthPodveska").value = lastLengthPodveska;
   // document.getElementById("poleState").value = lastPoleState;
   // document.getElementById("luminaireState").value = lastLuminaireState;

    // Находим элемент <input> по его id
    const numericInput = document.getElementById('lengthBetweenPoles');

    // Добавляем обработчик события ввода (input) к элементу
    numericInput.addEventListener('input', function (event) {
      // Получаем введенное значение
      const inputValue = event.target.value;

      // Удаляем все символы, которые не являются цифрами
      const numericValue = inputValue.replace(/[^0-9]/g, '');

      // Устанавливаем очищенное значение обратно в элемент <input>
      event.target.value = numericValue;
    });

  /*  const socleCountInput = document.getElementById('socleCount');
            socleCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const bannerCountInput = document.getElementById('bannerCount');
            bannerCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const podveskaCountInput = document.getElementById('podveskaCount');
            podveskaCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const lengthPodveskaInput = document.getElementById('lengthPodveska');
            lengthPodveskaInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const quantityPlafondInput = document.getElementById('quantityPlafond');
            quantityPlafondInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });*/

    if (GetLastInsertedId() != null) {
      document.getElementById("typeLines").value = lastTypeLine;

      poleNumberText.addEventListener("change", updateValue);
      function updateValue(e) {
        if (e.target.value != '1') {
          document.getElementById("addLineCheckbox").checked = true;
        }
        else {
          document.getElementById("addLineCheckbox").checked = false;
        }  
      } 
    }

        var polePopup = L.popup()
        .setContent(polePopupDiv)
        .setLatLng(latlng)
        .openOn(map);
        polePopupDiv.parentElement.style.width = "380px";
        document.getElementById('savePole').addEventListener('click', function () {
          this.disabled = true;
          SavePole(false, null, latlng, polePopup, null, linkedtp, null, this);
        });

    });
}

function CheckPoleDuplicate(linkedtp, number, oldNumber) {
  const encodedLinkedtp = encodeURIComponent(linkedtp);
  const encodedNumber = encodeURIComponent(number);
  return fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPoleByLinkedtpAndNumber/${encodedLinkedtp}/${encodedNumber}`)
    .then(response => response.json())
    .then(data => data.length > 0 && oldNumber != data[0].name);
}

// Проверяет, что указанный "Питающий центр" реально существует и является ПС
// (typecode = 13). Нужна для мобильного флоу, где, в отличие от десктопного
// SavePole, раньше такой проверки не было вообще. Экспортируется, чтобы
// использовать её же для ТП/РП/Реклоузера в objectManager.js.
export function CheckLinkedtpIsPS(linkedtp) {
  const encodedLinkedtp = encodeURIComponent(linkedtp);
  return fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPPbyName/${encodedLinkedtp}`)
    .then(response => response.json())
    .then(data => data.length > 0);
}

function AddPoleDirect(latlng, data) {
  const { number, linkedtp, poleType, textPosition, cableBrand, cableSection, lengthBetweenPoles } = data;
  const poleTypeId = String(poleType);

  SetLastLinkedObj(linkedtp);
  lastPoleNumber = parseInt(number) + 1;
  lastPoleType = poleTypeId;
  lastTextPosition = textPosition;
  lastCableBrand = cableBrand;
  lastCableSection = cableSection;
  lastLengthBetweenPoles = lengthBetweenPoles;

  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: number, linkedtp, typecode: poleTypeId,
      lat: latlng.lat, lng: latlng.lng, textPosition,
      countPlafond: null, poleState: null, luminaireBrand: null, luminaireState: null,
      cableBrand, userId: GetUserId(), username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(response => {
    const objectId = response.id;
    SetLastInsertedId(objectId);

    var circle = DrawPoleMarker(latlng, poleTypeId, null, number, 1, 2, textPosition, null, objectId, linkedtp).addTo(map);
    loadedMarkers.set(objectId, circle);
    SetLastInsertedMarker(circle);

    var foundObject = linkedtpArray.find(o => o.name === linkedtp);
    if (foundObject) {
      foundObject.children.push({ id: objectId, name: number, circle, typecode: poleTypeId, latlng });
    }

    PolePopupSetup(circle, number, linkedtp, latlng.lat, latlng.lng, objectId);
    PopupBehavior(circle, objectId, latlng, linkedtp, parseInt(poleTypeId), number);
    PushShowingLinkedObjects(linkedtp);

    const paramPoleTypeMap = { 2:17, 3:18, 4:19, 5:20, 14:21, 15:25, 16:26, 17:27, 18:28, 19:29, 20:30, 21:31, 22:1 };
    const paramPoleType = paramPoleTypeMap[poleType] || 1;
    UpdateParams(objectId, [52, 64, 75, 65], [paramPoleType, cableBrand, cableSection, lengthBetweenPoles]);
  })
  .catch(error => {
    console.error('Ошибка добавления опоры:', error);
    alert(`Не удалось добавить опору: ${error.message}`);
  });
}

function SavePole(isEdit, id, latlng, polePopup, iMarker, linkedtp, oldNumber, button) {
  if (!linkedtp) {
    document.getElementById("errorText").textContent = "Не выбран питающий центр:";
    button.disabled = false;
    return;
  }
  const encodedLinkedtp = encodeURIComponent(linkedtp);
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPPbyName/${encodedLinkedtp}`)
  .then(response => response.json())
  .then(data => {
    if (data.length < 1) {
      document.getElementById("errorText").textContent = "Данного ПП нет в списке объектов";
    } else {
      let objectNumber = document.getElementById('poleNumber').value;
      const encodedObjectNumber = encodeURIComponent(objectNumber);
      fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPoleByLinkedtpAndNumber/${encodedLinkedtp}/${encodedObjectNumber}`)
      .then(response => response.json())
      .then(data => {
        if (data.length > 0 && oldNumber != data[0].name) {
          document.getElementById("errorText").textContent = "Опора с таким номер уже существует ";
          button.disabled = false;
        } 
        else {
          if (!isEdit) {
            AddPole(latlng, polePopup, linkedtp);
          }
          else {
            EditPole(id, latlng, polePopup, iMarker, linkedtp); 
          }
        }
        
      });
    }
     
  });
}

function AddPole(latlng, popup, linkedtp) {
    var objectNumber = document.getElementById('poleNumber').value;

    var poleTypeId = String(poleType);
    var textPosition = parseInt(document.getElementById('textPosition').value);

    var cableBrand = parseInt(document.getElementById('cableBrand').value);
    var cableSection = parseInt(document.getElementById('cableSection').value);
    var lengthBetweenPoles = parseInt(document.getElementById('lengthBetweenPoles').value);

    if (GetLastInsertedId() != null) {
      var isLineAdd = document.getElementById("addLineCheckbox").checked;
      var typeLine =  parseInt(document.getElementById('typeLines').value);
      lastTypeLine = typeLine;
    }

    
    SetLastLinkedObj(linkedtp);
    lastPoleNumber = parseInt(objectNumber) + 1;

    lastPoleType = poleTypeId;
    lastTextPosition = textPosition;

    lastCableBrand = cableBrand;
    lastCableSection = cableSection;
    lastLengthBetweenPoles = lengthBetweenPoles;

    
    var paramcodeArray = [/*36, 46,*/ 52, 64, 75, 65/*, 61, 57, 59, 70, 73, 47*/];
    var paramPoleType = 0;
    switch(parseInt(poleTypeId)) {
      case 2: 
        paramPoleType = 17;
        break;
      case 3:
        paramPoleType = 18;
        break;
      case 4:
        paramPoleType = 19;
        break;
      case 5:
        paramPoleType = 20;
        break;
      case 14:
        paramPoleType = 21;
        break;
      case 15:
        paramPoleType = 25;
        break;
      case 16:
        paramPoleType = 26;
        break;
      case 17:
        paramPoleType = 27;
        break;
      case 18:
        paramPoleType = 28;
        break;
      case 19:
        paramPoleType = 29;
        break;
      case 20:
        paramPoleType = 30;
        break;
      case 21:
        paramPoleType = 31;
        break;
      case 22:
        paramPoleType = 1;
        break;
    }
    var paramvalueArray = [/*objectNumber, luminaireBrand,*/ paramPoleType, cableBrand, cableSection, lengthBetweenPoles, /*bracketBrand, lengthPodveska, socleCount, bannerCount, podveskaCount, quantityPlafond*/];
    
    var objectId;

    // Посылание информации на сервер методом POST
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
    //fetch(`${process.env.REACT_APP_BASE_URL}/objects_list`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: objectNumber, 
          linkedtp: linkedtp, 
          typecode: poleTypeId, 
          lat: latlng.lat, 
          lng: latlng.lng, 
          textPosition: textPosition, 
          countPlafond: null, 
          poleState: null,  
          luminaireBrand: null, 
          luminaireState: null, 
          cableBrand: cableBrand,
          userId: GetUserId(),
          username: GetUserName()
        })
      })
    .then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }
        return response.json().then(async response => {
            objectId = response.id;

            if (isLineAdd) {
              var position = GetLastInsertedMarker().getLatLng();

              AddLine(GetLastInsertedMarker().options.id, objectId, typeLine, position.lat, position.lng, latlng.lat, latlng.lng, linkedtp, GetLastInsertedMarker().options.name, objectNumber);
            }

           // lastInsertedId = objectId;
           SetLastInsertedId(objectId);

            var circle = DrawPoleMarker(latlng, poleTypeId, /*quantityPlafond*/null, objectNumber, 1, 2, textPosition, null, objectId, linkedtp).addTo(map);
            loadedMarkers.set(objectId, circle);
            SetLastInsertedMarker(circle);
            var childObject1_1 = {
                id: objectId,
                name: objectNumber,
                circle: circle,
                typecode: poleTypeId,
                latlng: latlng
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
                
                foundObject.children.push(childObject1_1);
              } else {
               // console.log('Объект с указанным именем не найден');
              }

            PolePopupSetup(circle, objectNumber, linkedtp, latlng.lat/*.toFixed(5)*/, latlng.lng/*.toFixed(5)*/, objectId);

            PopupBehavior(circle, objectId, latlng, linkedtp, parseInt(poleTypeId), objectNumber); 

            PushShowingLinkedObjects(linkedtp);
            /*await*/ UpdateParams(objectId, paramcodeArray, paramvalueArray);
          });
    })
    .catch(error => {
            console.error('Ошибка добавления опоры: ', error);
            alert(`Не удалось добавить опору: ${error.message}`);
    });

    map.closePopup(popup);

}

async function UpdateParams(objectId, paramcodeArray, paramvalueArray) {
  const apiUrl = `${process.env.REACT_APP_BASE_URL}/api/object_params/updateParams`;
  const dataToSend = {
    object_id: objectId,
    paramcodeList: paramcodeArray,
    paramvalueList: paramvalueArray
  };
    return fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataToSend)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Response from server:', data);
      })
      .catch(error => {
        console.error('Error sending POST request:', error);
      });  
}

export function EditPoleSetup(id, latlng, iMarker) {
    //fetch(`${process.env.REACT_APP_BASE_URL}/get_object_by_id/${id}`)
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/get_object_by_id/${id}`)
    .then(response => response.json())
    .then(data => {
        data.forEach(obj => { 

          if (isMobileVersion) {
            const container = document.createElement('div');
            document.body.appendChild(container);
            SetCurrentBottomSheet(container);

            const handleClose = () => {
              ReactDOM.unmountComponentAtNode(container);
              container.remove();
              ClearMarkerHighlight(iMarker); // редактирование закончено (сохранили или закрыли)
            };

             const handleBack = () => {
                                        ReactDOM.unmountComponentAtNode(container);
                                        container.remove(); // ← убрать контейнер
                            
                                        // Симулируем клик на маркер чтобы снова открылся ObjectBottomSheet
                                        if (iMarker) {
                                          iMarker.fire('click');
                                        }
                                      };

            // Питающим центром для опоры может быть только ПС (typecode = 13),
        // поэтому используем searchPP, а не общий searchPPandTP.
        const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;

            ReactDOM.render(
              <EditPoleSheet
                title="Редактировать опору"
                initialNumber={obj.name}
                initialLinkedtp={obj.linkedtp}
                initialPoleType={obj.typecode}
                initialTextPosition={obj.textPosition}
                initialCableBrand={obj.cableBrand || 1}
                initialCableSection={obj.cablesection || 1}
                initialLengthBetweenPoles={obj.lengthbetweenpoles || 0}
                searchLink={searchLink}
                onClose={handleClose}
                onBack={handleBack}
                onSave={(data) => {
                  CheckLinkedtpIsPS(data.linkedtp).then(isValidPS => {
                    if (!isValidPS) {
                      alert('Указанный питающий центр не найден среди ПС');
                      return;
                    }
                    CheckPoleDuplicate(data.linkedtp, data.number, obj.name).then(isDuplicate => {
                      if (isDuplicate) {
                        alert('Опора с таким номером уже существует');
                        return;
                      }
                      EditPoleDirect(id, latlng, iMarker, data, obj.name);
                      handleClose();
                    });
                  });
                }}
              />,
              container
            );
            return;
          }

            var polePopupDiv = document.createElement('div');
            polePopupDiv.id = 'polePopup';
            
            document.body.appendChild(polePopupDiv);

            document.getElementById('polePopup').innerHTML = GetPoleHtmlContent(obj.name, obj.linkedtp, true); //poleNumberContent + mainObjectNumberContent + popupContent + quantityPlafondContent + textPosition + submitContent;				

           // document.getElementById("poleType").value = obj.typecode;
            document.getElementById("textPosition").value = obj.textPosition;
          //  document.getElementById("quantityPlafond").value = obj.countPlafond;

          //  document.getElementById("poleState").value = obj.poleState;
         //   document.getElementById("luminaireBrand").value = obj.luminaireBrand;
         //   document.getElementById("bracketBrand").value = obj.bracketbrand;
          //  document.getElementById("luminaireState").value = obj.luminaireState;
            document.getElementById("cableBrand").value = obj.cableBrand;
            document.getElementById("cableSection").value = obj.cablesection;
            document.getElementById("lengthBetweenPoles").value = obj.lengthbetweenpoles;
          //  document.getElementById("socleCount").value = obj.soclecount;
          //  document.getElementById("bannerCount").value = obj.bannercount;
          //  document.getElementById("podveskaCount").value = obj.podveskacount;
         //   document.getElementById("lengthPodveska").value = obj.lengthpodveska;

            // Находим элемент <input> по его id
            const numericInput = document.getElementById('lengthBetweenPoles');

            // Добавляем обработчик события ввода (input) к элементу
            numericInput.addEventListener('input', function (event) {
              // Получаем введенное значение
              const inputValue = event.target.value;

              // Удаляем все символы, которые не являются цифрами
              const numericValue = inputValue.replace(/[^0-9]/g, '');

              // Устанавливаем очищенное значение обратно в элемент <input>
              event.target.value = numericValue;
            });

         /*  const socleCountInput = document.getElementById('socleCount');
            socleCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const bannerCountInput = document.getElementById('bannerCount');
            bannerCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const podveskaCountInput = document.getElementById('podveskaCount');
            podveskaCountInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const lengthPodveskaInput = document.getElementById('lengthPodveska');
            lengthPodveskaInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });

            const quantityPlafondInput = document.getElementById('quantityPlafond');
            quantityPlafondInput.addEventListener('input', function (event) {
              const inputValue = event.target.value;
              const numericValue = inputValue.replace(/[^0-9]/g, '');
              event.target.value = numericValue;
            });*/

            var linkedtp = obj.linkedtp;
            // Питающим центром для опоры может быть только ПС (typecode = 13),
        // поэтому используем searchPP, а не общий searchPPandTP.
        const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/searchPP?name=`;
            function handeleClickFind(id, name, lat, lng) {
              
              linkedtp = name;
            }
            
            const container = document.getElementById('divMainObjectNumber');
            ReactDOM.render(<div className="div__flex" ><label for="mainObjectNumber">Питающий центр: </label><div id="mainObjectNumber"><SearchComponent
              handeleClickFind={handeleClickFind}
              link={searchLink}
              home={false}
              propsValue={obj.linkedtp}
            ></SearchComponent></div></div>, container);     

            const containerPoleType = document.getElementById('divPoleType');
            ReactDOM.render(<div  ><label for="divPoleType">Тип опоры:</label><div id="divPoleType"><PoleTypeSelect initialValue={obj.typecode}
              /></div></div>, containerPoleType);

            var polePopup = L.popup()
            .setContent(polePopupDiv)
            .setLatLng(latlng)
            .openOn(map);
            // openOn закрыл попап опоры (и снял выделение) — выделяем снова на время
            // редактирования; снимется при закрытии формы (в т.ч. после сохранения)
            if (iMarker) {
              HighlightMarker(iMarker);
              polePopup.on('remove', () => ClearMarkerHighlight(iMarker));
            }
            polePopupDiv.parentElement.style.width = "350px";
            document.getElementById('savePole').addEventListener('click', function () {
              this.disabled = true;
              SavePole(true, id, latlng, polePopup, iMarker, linkedtp, obj.name, this);    
            });
        })
    });
}

function EditPoleDirect(id, latlng, iMarker, data, oldName) {
  const { number, linkedtp, poleType, textPosition, cableBrand, cableSection, lengthBetweenPoles } = data;
  const poleTypeId = String(poleType);

  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: number, linkedtp, typecode: poleTypeId,
      textPosition, countPlafond: null, poleState: null, luminaireBrand: null,
      luminaireState: null, cableBrand, id,
      userId: GetUserId(), username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(() => {
    SetLastLinkedObj(linkedtp);

    var newMarker = DrawPoleMarker(latlng, poleTypeId, null, number, 1, 2, textPosition, iMarker, id, linkedtp).addTo(map);
    PolePopupSetup(newMarker, number, linkedtp, latlng.lat, latlng.lng, id);
    PopupBehavior(newMarker, id, latlng, linkedtp, parseInt(poleTypeId), number);

    updatePolylineByFromId(id, number);
    updatePolylineByToId(id, number);

    const paramPoleTypeMap = { 2:17, 3:18, 4:19, 5:20, 14:21, 15:25, 16:26, 17:27, 18:28, 19:29, 20:30, 21:31, 22:1 };
    const paramPoleType = paramPoleTypeMap[poleType] || 1;
    UpdateParams(id, [52, 64, 75, 65], [paramPoleType, cableBrand, cableSection, lengthBetweenPoles]);
  })
  .catch(error => {
    console.error('Ошибка обновления опоры:', error);
    alert(`Не удалось сохранить опору: ${error.message}`);
  });
}

function EditPole(id, latlng, popup, iMarker, linkedtp) {
    var objectNumber = document.getElementById('poleNumber').value;
    var poleTypeId = String(poleType);
    var textPosition = parseInt(document.getElementById('textPosition').value);

    var cableBrand = parseInt(document.getElementById('cableBrand').value);
    var cableSection = parseInt(document.getElementById('cableSection').value);
    var lengthBetweenPoles = parseInt(document.getElementById('lengthBetweenPoles').value);

    SetLastLinkedObj(linkedtp);
    lastPoleNumber = parseInt(objectNumber) + 1;
    var paramPoleType = 0;
    switch(parseInt(poleTypeId)) {
      case 2: 
        paramPoleType = 17;
        break;
      case 3:
        paramPoleType = 18;
        break;
      case 4:
        paramPoleType = 19;
        break;
      case 5:
        paramPoleType = 20;
        break;
      case 14:
        paramPoleType = 21;
        break;
      case 15:
        paramPoleType = 25;
        break;
      case 16:
        paramPoleType = 26;
        break;
      case 17:
        paramPoleType = 27;
        break;
      case 18:
        paramPoleType = 28;
        break;
      case 19:
        paramPoleType = 29;
        break;
      case 20:
        paramPoleType = 30;
        break;
      case 21:
        paramPoleType = 31;
        break;
      case 22:
        paramPoleType = 1;
        break;
    }
    
    var paramcodeArray = [/*36, 46,*/ 52, 64, 75, 65/*, 61, 57, 59, 70, 73, 47*/];
    var paramvalueArray = [/*objectNumber, luminaireBrand,*/ paramPoleType, cableBrand, cableSection, lengthBetweenPoles, /*bracketBrand, lengthPodveska, socleCount, bannerCount, podveskaCount, quantityPlafond*/];

    iMarker = DrawPoleMarker(latlng, poleTypeId, /*quantityPlafond*/null, objectNumber, 1, 2, textPosition, iMarker, id, linkedtp).addTo(map);
    PolePopupSetup(iMarker, objectNumber, linkedtp, latlng.lat.toFixed(5), latlng.lng.toFixed(5), id);

    var childObject1_1 = {
        id: id,
        name: objectNumber,
        circle: iMarker
      };

      // Используем метод find() для поиска объекта по имени
      var foundObject = linkedtpArray.find(function(mainObject) {
        return mainObject.name === linkedtp;
      });
      
      if (foundObject) {
       
        foundObject.children.push(childObject1_1);
      } else {
       // console.log('Объект с указанным именем не найден');
      }

      updatePolylineByFromId(id, objectNumber);
      updatePolylineByToId(id, objectNumber);

    // Посылание информации на сервер методом POST
    //fetch(`${process.env.REACT_APP_BASE_URL}/upd_object_by_id`, {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: objectNumber, 
          linkedtp: linkedtp, 
          typecode: poleTypeId, 
          textPosition: textPosition, 
          countPlafond:  null, 
          poleState: null,  
          luminaireBrand: null, 
          luminaireState: null, 
          cableBrand: cableBrand, 
          id: id,
          userId: GetUserId(),
          username: GetUserName() 
        })
      })
    .then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }
        PopupBehavior(iMarker, id, latlng, linkedtp, parseInt(poleTypeId), objectNumber);
        UpdateParams(id, paramcodeArray, paramvalueArray);
    })
    .catch(error => {
            console.error('Ошибка обновления опоры: ', error);
            alert(`Не удалось сохранить опору: ${error.message}`);
    });

    map.closePopup(popup);
}

export function PolePopupSetup(circle, objectNumber, linkedtp, lat, lng, id) {

  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();

    const entry = departmentAccessArray.find(entry => {
      if (linkedtp === null) {
          return entry.startsWith("00=");
      } else {
          return entry.startsWith(linkedtp.substring(0, 2) + "=") || entry.startsWith("00=");
      }
  });
    if (entry) {
      // Если строка найдена, получаем значение
      const value = entry.split("=")[1];
      switch (value) {
        case '1':
        case '2':
          isEditable = true;
          
          break;
        case '3':
          isEditable = false;
          break;
      }
    }

  var editButtons = `<button id="editObject${id}" class="simple_button">Редактировать</button><button id="deleteObject${id}" class="simple_button">Удалить</button><button id="addLine${id}" class="simple_button">Добавить линию</button><button id="passport${id}" class="simple_button">Паспорт</button>`;

    if (/*GetUserName() === 'azhalpakov' || isMobileVersion ||*/ !isEditable) {
      editButtons = `<button id="editObject${id}" class="simple_button" style="display: none;">Редактировать</button><button id="deleteObject${id}" class="simple_button" style="display: none;">Удалить</button>
      <button id="addLine${id}" class="simple_button" style="display: none;">Добавить линию</button>`;
    }

    circle.off('click');
  // Привяжите событие popupopen к маркеру
circle.on('click', function () {
  if (!isMobileVersion) {
    if (lastMyDiv) {
      lastMyDiv.remove();
    }
    const latlng = circle.getLatLng(); 
    var popupContent = `<b>Опора ${objectNumber} от ${circle.options.linkedtp}</b><br>Координаты: ${latlng.lat}, ${latlng.lng}<br>` +
    `${editButtons}`;
    var myDiv = document.createElement('div');
    
    myDiv.innerHTML = popupContent;
    var popup = L.popup()
              .setContent(myDiv)
              .setLatLng(latlng)
              .openOn(map);     
    SetLastOpenedPopup(popup); 
    lastMyDiv = myDiv;
    // Выделяем после openOn: он закрывает предыдущий попап, и если это был попап
    // этой же опоры, его 'remove' снял бы только что поставленное выделение
    HighlightMarker(circle);
    popup.on('remove', () => ClearMarkerHighlight(circle));
    return;
  }

  // Мобильный — Bottom Sheet
  HighlightMarker(circle);
    const container = document.createElement('div');
    document.body.appendChild(container);
    SetCurrentBottomSheet(container);

    // При переходе к редактированию или добавлению линии шторка объекта закрывается,
    // но выделение оставляем — его снимет следующая форма (сохранение / закрытие)
    let keepHighlight = false;

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
      if (!keepHighlight) ClearMarkerHighlight(circle);
    };

    const handleAddLine = () => {
      const addLineContainer = document.createElement('div');
      document.body.appendChild(addLineContainer);
      SetCurrentBottomSheet(addLineContainer);

      // Если начали рисовать кривую линию — выделение держим до конца рисования
      // (его снимет обработчик DRAWSTOP в Main.js)
      let curveStarted = false;

      const handleAddLineClose = () => {
        ReactDOM.unmountComponentAtNode(addLineContainer);
        addLineContainer.remove();
        if (!curveStarted) ClearMarkerHighlight(circle);
      };

      const handleAddLineBack = () => {
              ReactDOM.unmountComponentAtNode(addLineContainer);
              addLineContainer.remove();
              circle.fire('click'); // ← открываем ObjectBottomSheet заново
            };

      const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${linkedtp}&name=`;
      const markerLatlng = circle.getLatLng();

      const handleAddLineSubmit = (selectedObject, typecode) => {
        if (typecode === '7c') {
          curveStarted = true;
          StartCurveLine(markerLatlng, {
            from_id: id,
            to_id: selectedObject.id,
            typecode: '7',
            linkedtp,
            start_name: objectNumber,
            end_name: selectedObject.name,
            end_lat: selectedObject.lat,   // ← добавить
            end_lng: selectedObject.lng
          }, circle);
        } else {
          AddLine(id, selectedObject.id, typecode,
            markerLatlng.lat, markerLatlng.lng,
            selectedObject.lat, selectedObject.lng,
            linkedtp, objectNumber, selectedObject.name
          );
        }
      };

      ReactDOM.render(
        <AddLineSheet
          onClose={handleAddLineClose}
          onAddLine={handleAddLineSubmit}
          searchLink={searchLink}
          onBack={handleAddLineBack}
        />,
        addLineContainer
      );
    };

    ReactDOM.render(
      <ObjectBottomSheet
        title={objectNumber}  
        subtitle={`Координаты: ${lat}, ${lng}`}
        isEditable={isEditable}
        onEdit={() => { keepHighlight = true; EditPoleSetup(id, circle.getLatLng(), circle); }}
        onDelete={() => DeleteObjectWithConfirm(id, circle)}
        onAddLine={() => { keepHighlight = true; handleAddLine(); }}
        onPassport={() => OpenSideBar(true)}
        onClose={handleClose}
      />,
      container
    );

});

}

function GetPoleHtmlContent(objectName, linkedtp, isEdit) {
    var style = 'style="width: 12px; height: 12px; border-width: 2px;"';

    var poleNumberContent = '<label for="poleNumber">Номер опоры: </label><input type="text" id="poleNumber" name="poleNumber" value="' + objectName + '">';
    //<label for="mainObjectNumber">Номер связанного ПП: </label><input type="text" id="mainObjectNumber" name="mainObjectNumber" value="' + linkedtp + '">
    var mainObjectNumberContent = '<br><div id="divMainObjectNumber"></div>';

       /* var popupContent = '<fieldset><legend>Выберете тип опоры:</legend>' +
        '<select id="poleType" name="poleType">' +
        '<option value="22">-</option>' +
        '<option value="2">стальная граненная коническая СГКФ улица</option>' +
        '<option value="15">стальная граненная коническая СГКФ двор</option>' +
        '<option value="16">стальная граненная коническая СГКФ магистраль</option>' +
        '<option value="3">стальная коническая СКФ улица</option>' +
        '<option value="17">стальная коническая СКФ двор</option>' +
        '<option value="18">стальная коническая СКФ магистраль</option>' +
        '<option value="19">труба стальная сварная улица</option>' +
        '<option value="20">труба стальная сварная двор</option>' +
        '<option value="21">труба стальная сварная магистраль</option>' +
        '<option value="4">ж/б</option>' +
        '<option value="5">деревянная</option>' +
        '<option value="14">торшерная</option>' +
        '</select>' +
        '</fieldset>';*/  
        
        var popupContent = `<br><div id="divPoleType"></div>`

      

    var poleState = '<br><label for="poleState">Состояние опоры: </label>' +
        '<select name="poleState" id="poleState">' +
        '<option value="0">Хорошее</option>' +
        '<option value="1">Удовлетворительное</option>' +
        '<option value="2">Требуется окраска</option>' +
        '<option value="3">Имеет повреждения</option>' +
        '</select><br>'

   var quantityPlafondContent = '<label for="quantityPlafond">Количество плафонов: </label><input type="number" value="1" id="quantityPlafond" name="quantity" min="0" max="100">';

    var textPosition = '<br><label for="textPosition">Расположение номера: </label>' +
        '<select name="textPosition" id="textPosition">' +
        '<option value="0">Сверху</option>' +
        '<option value="1">Справа</option>' +
        '<option value="2">Снизу</option>' +
        '<option value="3">Слева</option>' +
        '<option value="4">Не отображать</option>' +
        '</select><br>'

    var luminaireBrand = '<br><label for="luminaireBrand">Марка светильника: </label>' +
        '<select name="luminaireBrand" id="luminaireBrand">' +
        '<option value="1">-</option>' +
        '<option value="2">РКУ ДРЛ 125 Вт</option>' +
        '<option value="3">РКУ ДРЛ 250 ВТ</option>' +
        '<option value="4">ЖКУ ДНаТ 70 ВТ</option>' +
        '<option value="5">ЖКУ ДНаТ 100 ВТ</option>' +
        '<option value="6">ЖКУ ДНаТ 150 ВТ</option>' +
        '<option value="7">ДКУ LED 50 Вт</option>' +
        '<option value="8">ДКУ LED 60 Вт</option>' +
        '<option value="9">ДКУ LED 100 Вт</option>' +
        '<option value="10">ДКУ LED 150 Вт</option>' +
        '<option value="11">ДКУ LED 200 Вт</option>' +
        '</select><br>'

    var luminaireState = '<br><label for="luminaireState">Состояние светильника: </label>' +
        '<select name="luminaireState" id="luminaireState">' +
        '<option value="0">Хорошее</option>' +
        '<option value="1">Удовлетворительное</option>' +
        '<option value="2">Неудовлетворительное</option>' +
        '<option value="3">Имеет повреждения</option>' +
        '</select><br>'
      
    var bracketBrand = '<br><label for="bracketBrand">Марка кронштейна: </label>' +
        '<select name="bracketBrand" id="bracketBrand">' +
        '<option value="1">-</option>' +
        '<option value="32">К-1 (однорожковый)' +
        '<option value="33">К-2 (двухрожковый)</option>' +
        '<option value="34">К-3 (трехрожковый)</option>' +
        '<option value="35">К-4 (четырехрожковый)</option>' +
        '</select><br>'

    var cableBrand = '<br><label for="cableBrand">Марка кабеля: </label>' +
        '<select name="cableBrand" id="cableBrand">' +
        '<option value="1">-</option>' +
        '<option value="12">АВБбШв</option>' +
        '<option value="13">СИП</option>' +
        '<option value="14">АВВГ</option>' +
        '<option value="15">АПВ</option>' +
        '<option value="16">А</option>' +
        '<option value="142">АС</option>' +
        '</select><br>'

    var cableSection = '<br><label for="cableSection">Сечение кабеля: </label>' +
        '<select name="cableSection" id="cableSection">' +
        '<option value="1">-</option>' +
        '<option value="22">4x10 мм²</option>' +
        '<option value="23">4x16 мм²</option>' +
        '<option value="24">4x25 мм²</option>' +
        '<option value="143">95 мм²</option>' +
        '<option value="144">70 мм²</option>' +
        '<option value="145">50 мм²</option>' +
        '<option value="146">35 мм²</option>' +
        '</select><br>'
      
    var socleCount = '<br><label for="socleCount">Количество цоколей: </label><input type="text" id="socleCount" name="socleCount" value="">';
    var bannerCount = '<br><label for="bannerCount">Количество рекламных баннеров: </label><input type="text" id="bannerCount" name="bannerCount" value="">';
    var podveskaCount = '<br><label for="podveskaCount">Количество совместных подвесок: </label><input type="text" id="podveskaCount" name="podveskaCount" value="">';
    var lengthPodveska = '<br><label for="lengthPodveska">Совместная подвеска, м: </label><input type="text" id="lengthPodveska" name="lengthPodveska" value="">';

    var lengthBetweenPoles = '<br><label for="lengthBetweenPoles">Длина между опорами ср., м: </label><input type="text" id="lengthBetweenPoles" name="lengthBetweenPoles" value="">';
    
        var addLineCheckBox = '';
    if (!isEdit && GetLastInsertedId() != null) {    
      var checkStatus = '';    
      if (objectName != '1') {
        checkStatus = 'checked';
      }   
      addLineCheckBox = `<input type="checkbox" id="addLineCheckbox" ${checkStatus}/>
      <label for="addLineCheckbox">Добавить линию к последнему добавленном объекту</label>`; 
      var typeLine = '<br><label for="typeLines">Тип линии </label>' +
        '<select name="typeLines" id="typeLines">' +
        '<option value="8">Воздушная</option>' +
        '<option value="7">Кабельная</option>' +
        '</select><br>'
        addLineCheckBox += typeLine; 
        
    } 
    addLineCheckBox += cableBrand + cableSection + lengthBetweenPoles;
    var submitContent = '<br><button id="savePole" class="simple_button">Сохранить</button><span class="error-text" id="errorText"></span>';
    
    var htmlContent = poleNumberContent + mainObjectNumberContent + popupContent + /*poleState + quantityPlafondContent + luminaireBrand + luminaireState +*/ textPosition + /*bracketBrand + */
      /*socleCount + bannerCount + podveskaCount + lengthPodveska +*/ addLineCheckBox + submitContent;
    return htmlContent;
}

export function GetHtmlObject(poleType, style, styleNoBorder, quantityPlafond, objectNumber, textPosition) {
  const plafondText = quantityPlafond ?? ''; 
  var textClass = '';
  switch (textPosition) {
    case 0:
      textClass = '<span class="text-top">' + objectNumber + '</span>';
      break;
    case 1:
      textClass = '<span class="text-right">' + objectNumber + '</span>';
      break;
    case 2:
      textClass = '<span class="text-bottom">' + objectNumber + '</span>';
      break;
    case 3:
      textClass = '<span class="text-left">' + objectNumber + '</span>';
      break;
    case 4:
      textClass = '';
      break;
  }
  var htmlObject;
  switch (poleType) {
    case '2':
    case '15':
    case '16':
      htmlObject = textClass + '<div class="octagonWrap"' + style + '><span class="octagon"><span class="octagon-text-rotate"><span class="octagon-text">' + plafondText + '</span></span></div>';
      break;
    case '3':
    case '17':
    case '18':
      htmlObject = '<span class="' + 'circle circle1" ' + style + '>' + plafondText + '</span>' + textClass
      break;
    case '19':
    case '20':
    case '21':
      htmlObject = `<div style="position: relative;"><img src=${imageSrcWelded} ${styleNoBorder}/><div class="text-triangle">${plafondText}</div>${textClass}</div>`;
      break;
    case '22':
      htmlObject = `<div style="position: relative;"><img src=${imageSrcNoType} ${styleNoBorder}/>${textClass}</div>`;
      break;
    case '4':
      htmlObject = '<span class="' + 'single-square square1" ' + style + '>' + plafondText + '</span>' + textClass;
      break;
    case '5':
      htmlObject = '<div class="circle3"' + style + '>' + plafondText + '<span class="square">' + '</span>' + textClass + '</div>';
      break;
    case '14':
      htmlObject = `<div style="position: relative;"><img src=${imageSrcTriangle} ${styleNoBorder}/>${textClass}</div>`;
      break;
  }
  return htmlObject;
}